import { render, staticRenderFns } from "./CalendarAbout.Dialog.vue?vue&type=template&id=cab3bc1c&scoped=true&"
import script from "./CalendarAbout.Dialog.vue?vue&type=script&lang=js&"
export * from "./CalendarAbout.Dialog.vue?vue&type=script&lang=js&"
import style0 from "./CalendarAbout.Dialog.vue?vue&type=style&index=0&id=cab3bc1c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab3bc1c",
  null
  
)

export default component.exports